import * as yup from "yup";
import {
  fieldMaxLength,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

export const myFamilyWizardFormSchema = yup
  .object({
    id: yup.number().required().defined(),

    name: yup
      .string()
      .required(requiredField("Име"))
      .trim()
      .max(200, fieldMaxLength("Име", 200))
      .defined(),

    familyHeadId: yup.number().nullable().defined(),

    members: yup.array().optional().defined(),
  })
  .required();

export type IMyFamilyWizardFormModel = yup.InferType<
  typeof myFamilyWizardFormSchema
>;

export const myFamilyWizardFormDefaultValues: IMyFamilyWizardFormModel = {
  id: 0,
  name: "",
  familyHeadId: 0,
  members: [],
};
